// extracted by mini-css-extract-plugin
export default {"gallery-setting":"App_gallery-setting__ZV9Hc","button-33":"App_button-33__l6o0M","email":"App_email__3lys3"};